import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Button,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";

const TARGET_SCREEN_LABELS = {
  home: "Home",
  webinar: "Webinar",
  training: "Training",
};

export default function BannerTable({
  bannerData,
  onEdit,
  onDelete,
  onStatusChange,
}) {
  console.log("banner data", bannerData);
  return (
    <TableContainer component={Paper} className="customTable">
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            {/* <TableCell>Id</TableCell> */}
            <TableCell>Title</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Desktop</TableCell>
            <TableCell>Mobile</TableCell>
            <TableCell>ButtonText</TableCell>
            <TableCell>ButtonLink</TableCell>
            <TableCell>Target Screen</TableCell>
            <TableCell>Order</TableCell>
            <TableCell>Expiry Date</TableCell>
            <TableCell>Create Date</TableCell>
            <TableCell>Update Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bannerData.map((banner, index) => (
            <TableRow key={banner.id || index}>
              {/* <TableCell>{index + 1}</TableCell> */}
              <TableCell>{banner.title}</TableCell>
              <TableCell>{banner.description}</TableCell>
              <TableCell>{banner.webImageS3Key}</TableCell>
              <TableCell>{banner.mobileImageS3Key}</TableCell>
              <TableCell>{banner.buttonText}</TableCell>
              <TableCell>{banner.buttonLink}</TableCell>
              <TableCell>
                {TARGET_SCREEN_LABELS[banner.targetScreen] ||
                  banner.targetScreen}
              </TableCell>
              <TableCell>{banner.ord}</TableCell>
              <TableCell>
                {banner.expireAt
                  ? new Date(banner.expireAt).toLocaleDateString("en-CA")
                  : ""}
              </TableCell>
              <TableCell>
                {banner.createdAt
                  ? new Date(banner.createdAt).toISOString().split("T")[0]
                  : ""}
              </TableCell>
              <TableCell>
                {banner.updatedAt
                  ? new Date(banner.updatedAt).toISOString().split("T")[0]
                  : ""}
              </TableCell>
              <TableCell>
                <Switch
                  checked={banner.status}
                  color="primary"
                  onChange={() => onStatusChange(banner.id)}
                />
              </TableCell>
              <TableCell>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={
                    <EditIcon style={{ color: "#035eab", fontSize: "1rem" }} />
                  }
                  style={{ marginRight: "8px" }}
                  onClick={() => onEdit(banner)}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  startIcon={
                    <DeleteIcon
                      style={{ color: "#ff4500", fontSize: "1rem" }}
                    />
                  }
                  onClick={() => onDelete(banner.id)}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
